<template>
  <div
    class="card-process"
    :class="[
      data.complete ? 'complete' : '',
      data.id === getProcessSelected.id ? 'selected' : '',
    ]"
  >
    <div class="card-content" @click="setProcessSelected(data.id)">
      <p>{{ data.id }}</p>
      <div class="process-info">
        <div class="card-process-row">
          <span class="porcent" data-v-step="9">{{ data.porcent }}%</span>
          <span class="state">
            <svg
              v-if="data.LastInteraction"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="23"
              height="23"
              viewBox="0 0 23 23"
            >
              <image
                id="icons8-consulta-100_1_"
                data-name="icons8-consulta-100 (1)"
                width="23"
                height="23"
                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAJIElEQVR4nO2dbXBUVxnH/8/dTbJACuVlkxDiCG1gNyyt2Hyw1ZEPtsoM0kEa3RCgjjpIQKtUrSNaZ8QPvlRnUPulAVo7Vlqyt0J1iNH6Mv2gVTs0tSPkFQSVANkNCPISQrL3PH4gSW82u7mb3XvOvZvc3wwznLvnPv9n9p9zzz33nHsW8PDwyAw5nUC+tOuR4iCM7QxsBWMVgDlO5zTCDQDHCXSwn7QDkWj7UDYnFbQh/YdClcJHLWC81+lcLHhL89P6YF3nBauKmopsZNCuR4oLxAwAuE8k+Sjvqy2yqliwhgRhbC8QM0apTcy/vs2qkl9FJjJgYKu5TMBRErwj2NB93qmczFzUVywR0JqYsX7sINOjAJ6Z7LyCbSFgRMxFjcROt5gBAIuiPed8vuTOlMOrrM4rXEOAUnNhUbTnnFOJZGJh3anelEN3WJ1TyIZMS1zVh/TpoWUE+jAz7ifgbgB3AbhKLJ4o29TzG6fzU4HjhpzVq2YVo/RRMB4D4x5g4uCISfsZ61hMURgOpKgURw3pi4UbiPEjAOUWVYPoAOejFY+Fczq/vL5r3N9Hpjip9XLFEUMSeqSUIQ6CeUO259AeCJk5uQXlhiT0SAXDaC2wQZ0ylN5lnXl+aYBh/NIzIzNKW8js2YEmMN6nUnMUu67xdsXJhLIWkojVrAHwSVV6hYoyQxj8NAr8cb8KlBgy0jreo0Kr0FFiCIM/o0JnOiDdEGYQgI/I1pkuSL/LisdqIkS8WLaOdR7ZjbDtGtHnivxLFvE90jWmEdINISAkW2M6Ib+FMBy/XBUS8kfqhAXSNbIg22u87JG4FSpue4sVaEwbFBjCM+KxuV0o6NRpULbGdELFwFDW0pxr5sJFfcUSSTo5c+lwdVXKoWtpK5pQMA6RZAihw1wU0JrcZMqlw9VVw0l/U8rhE1bnSb/LYuC8Hbct/9Xvmrcgevp/o2Vi+jmDx+ZWmLHegNYbj4UzhbjAQGNFfdfRdB/2xcIPE9AEoNKGdJFMpnu0zS9YnSe9hfhsaiFDoqTGXO4n7QCAt6YQYjEBB1iHL/WD80drZxPwHGwyIx0EHCu7UvqcVT3phgwZ/tN2xCHiT5nLkWj7kOan9QDaphCm/KIRmjB97B+4vg1AMM8UM8KEN8lPG6ixbdiqrnRDljScOAsgbkOobYlDKz9oPhCs67xQdmXOAyD+HAh/AXDdKoggqjWXb6+Aoa/bkF8q12/nxDvLL895fzbvhgCK5tQZ3EagdXmG8bEmWhJ6qL4s2v3b0YMjf3XPIMOq8ngs/C0Ae8YOEK02fy6E8SQRKkyH+gYGBpct+/S/HLldVzJBRUxv2hRqLjO1xmPhX8RjNQ/1/ypkuXiZQMfMZQaP9UXxl0L3EuErKfV/7JQZgKoWonEbsW2PiAhAHcB1YpBguqu6BuAPGmN3cFNXz5i2IXrhI/PJQQC4/MrqO4eGBnUA5reaTt0YuPkTuxLNBTWLHJjyWgaaJXcA2CgIfzUPyMjvHxhfjUrOPL80MDQ8GMPEqYHHnGwdgAJDeo+EFxLwU9k6JhYkjaK9owUhRGD8x1wye3bgVfCEaeUD5fVdryrIb1KkX7KKh+lxBi+SrTMO5rXvFMTdKUO0qpF/YxBw7MbA4BeV5GaB/GdZ4I/J1kjD3Hf+Sw9Z1O3WSGx0+lI1iopOfZkCjYwQmV66nAC/zUXJtYse+WdCXUaTo6JTn/CoQjHpbigEGPu1ANZUuMgMQMnDRe4n0Ltk60ySwA4QmgCUAThN4D8mWeyv3HSy07GcJkH6/HE8FnoFIOX9iBbgucEN3ZbzD25DfqdOWotsjbS6t7DWupb7kG7IzRs3XwSkzRpmRDD29h4JL1Stmy9KlrwkYjXrGNyiSs9ELzF/2a8N/848ueVmlH1B8Vi4DozvgbBclWYK5zSixmC089cO6WeF0r9YZlDi5dDvwfSgSl0T58rru1IXHrgKpS99EoEhtB7rmtKY76B2Vqjf64TYlindnGCccUw7S5QbQizaVWuOwsBrTmlni3JDfEnxOoCsNoS0G401ldMAOaHckIVbT10lQP28A+GNsoaOvyvXnSKO7JfF4KeQ/qGfNEiIb6vUyxVHDCmv734dwBFVegQ0F8p+W87tKGf4Pw/gP9J1GO1FxYHUvQ9di6NvCyX0yGpmQ+p13SDfuyuj7fKNtwlH91wMdrT/Q7bG4o721I0oXY23CabL8AxxGZ4hLsMzxGV4hrgMRw25UFsbsK6VH70rq0pka9iJo4b4BwZkvCgzjmIu/ZpsDTtxbGAYbw4/AoIO+QvpDCbaUhHtjEnWsQXlLYQZ1KeHdoHQDDWrGn3EfDAeC+/hPe7vM5W2kP7mmvsE8dMAPqBSdxQCjgmhfaGioeMNJ/SzQYkh/Xq4VgjeBaLNcH6tryBCKzN/f+Sps6uQZgjvgRYPhx4moq/CoRZhDf2ZwT8oj3a1EKmdn8mE7Ybcfs3Y2AzGLgAr7Y4viVMEeraouGTf/I1vX3EyEdsM6dNDy4jRCNBnAXdsWpYDV8Fo1jTeG4x2dzuRQN6G9DXXrNKIn2Qgiukz8jcA6MLQvrN4c4fSVTI5G3LhUHgpafQUgT+RTxyXIwjQk37aXVnX+W8VglP+Ik+2VpfMu1b0TQY/AUD6ow+XcBOMH16dm/zu8nWnbskUmpIh55uX1/g034sz+Pc/TsDgLeWbu6XNdGZ9ze/Ta+p95GubwWYAwCr46G+JWCgqSyArQ+Kx0A5ifgnALFmJFBCzGNTc11zzuIzglpesuB7eDsY+GeIFD6GxPNq1396QkxDXww+A8RqAgppTUMgwCe3BsoaOP9kVMKMhZ/XIgmI2jkPitnfThPMlyaJVd245ftmOYBn7kGI2vgHPjGyovOVL2jbRlraFXDpcXZVM+nvgdeLZMmiQL2THCsm0LSSZ9O+GZ8ZUCPg5+SU7Ak0w5GRrdQmAzXYEn0kw6OMjP++UFxMMmXu9aA0K4OVIF1KVeDl8f75BJhjCgj+Ub9CZCgn6aL4xJhhChNp0FT2sYeK8v7t0nXp1vkFnLIwV+YZIZ4j3m1G5QvmP28YZktAjpZg5cxwyCPS9cO+cfAJo4wvD8/LLx8NXdMv7Dj08PDw8HOH/3mu2qdJWZg0AAAAASUVORK5CYII="
              />
            </svg>
          </span>
        </div>
        <span class="process-name">{{ data.name }}</span>
      </div>
    </div>
    <div
      class="card-process-btn"
      :data-v-step="data.id === '1.3' ? 14 : 100000"
      :class="data.inProcess ? 'process' : ''"
    >
      <font-awesome-icon icon="arrow-right" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["getProcessSelected"]),
  },
  methods: {
    ...mapMutations(["setProcessSelected"]),
  },
};
</script>

<style scoped>
.card-process {
  display: flex;
  align-items: center;
  margin: 0 10px;
}
.card-process:hover {
  transform: scale(1.1);
  transition: 0.5s;
}

.card-content {
  display: flex;
  flex-direction: column;
  width: 146px;
  height: 105px;
  background: #fff;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: 0.5s linear;
}

.card-process.complete .card-content {
  background: var(--third-color);
  color: #fff;
}

.card-process.complete .card-content .process-name {
  color: #fff;
}
.card-process.complete .card-content p {
  color: var(--eighth-color);
  font-size: 0.7rem;
}

.card-content p {
  font-family: "PT Sans", sans-serif;
  font-weight: bold;
  font-size: 0.8rem;
  margin: 2pt 10px 0 10px;
  color: #e8d34e;
}

.card-content .card-process-row {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}

.card-content .card-process-row .porcent {
  color: var(---sixth-color);
  font-size: 1.5rem;
  padding: 0;
  text-align: left;
}
.card-content .card-process-row .state {
  padding: 0;
}
.card-content .process-name {
  margin-left: 20px;
  text-align: left;
  height: 100%;
  color: black;
  font-size: 0.8rem;
}
.card-process-btn {
  margin-left: -5px;
  width: 12px;
  height: 75px;
  background: var(--sixth-color);
  font-size: 6pt;
  color: var(--fifth-color);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.card-process.selected .card-process-btn {
  background: var(--third-color);
  color: var(--sixth-color);
  transition: 0.5s;
}
.card-process.selected .card-content {
  background: #eaeaea;
}
.card-process.selected .card-content .process-name {
  font-weight: bold;
  transition: 0.5s;
}

.process-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>